<script lang="ts">
    export let text: string | undefined;
    export let onClick: () => void = () => {};

    export let borderColor: string = "accent";
    export let textColor: string = "accent";
    export let bgColor: string = "transparent";
    export let rounded: string = "subtle";

    export let fullWidth: boolean = false;
    export let fullWidthOnMobile: boolean = false;

    export let bigButton: boolean = false;
</script>

<button
    on:click={onClick}
    class="whitespace-nowrap bg-no-repeat text-light border-[3px] px-6 py-1 font-medium lg:font-normal text-base slide-animation"
    class:border-accent={borderColor == "accent"}
    class:bg-accent-gradient={borderColor == "accent"}
    class:hover:text-light={(borderColor == "accent" || borderColor == "dark") && bgColor == "transparent"}
    class:text-accent={textColor == "accent"}
    class:hover:text-accent={bgColor == "accent"}
    class:border-light={borderColor == "light"}
    class:bg-light-gradient={borderColor == "light" && bgColor == "transparent"}
    class:hover:text-dark={borderColor == "light" && bgColor == "transparent"}
    class:text-light={textColor == "light"}
    class:bg-light={bgColor == "light"}
    class:border-dark={borderColor == "dark"}
    class:bg-dark-gradient={borderColor == "dark" && bgColor == "transparent"}
    class:text-dark={textColor == "dark"}
    class:!px-12={bigButton}
    class:sm:!py-3={bigButton}
    class:!py-2={bigButton}
    class:!text-xl={bigButton}
    class:!rounded-2xl={bigButton}
    class:lg:w-auto={fullWidthOnMobile}
    class:w-full={fullWidthOnMobile || fullWidth}
    class:rounded-full={rounded == "full"}
    class:lg:rounded-2xl={rounded == "large"}
    class:rounded-lg={rounded == "subtle" || rounded == "large"}
    class:bg-right={bgColor == "transparent"}
    class:hover:bg-left={bgColor == "transparent"}
    class:bg-left={bgColor != "transparent"}
    class:hover:bg-right={bgColor != "transparent"}
>
    {text}
</button>

<style>
    .slide-animation {
        background-size: 200%;
        transition: 0.2s ease-out;
    }
</style>
